import { Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { MdClose } from "react-icons/md";
import { setLocalTime } from "../../../utils";
import { useSelector } from "react-redux";

const ProcessModal = (props) => {
  const { t } = useTranslation();
  const lang = useSelector((state) => state.language.lang);
  const { openAbout, setOpenAbout, steps, item } = props;

  return (
    <Modal
      open={openAbout}
      onOk={() => setOpenAbout(false)}
      onCancel={() => setOpenAbout(false)}
      centered
      title={null}
      footer={null}
      closeIcon={<MdClose className="icon" />}
      width={1060}
      className="add-fcc-modal"
    >
      <h1>{t("inner-fcc.sos-ot")}</h1>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>№</th>
              <th>{t("inner-fcc.sos-ot")}</th>
              <th>{t("inner-fcc.vrem")}</th>
            </tr>
          </thead>
          <tbody>
            {steps?.map((item1, index1) => {
              return (
                <tr key={index1}>
                  <td>{index1 + 1}</td>
                  <td>
                    {item1[`status_${lang}`]}
                    <br />
                    {item?.is_cancelled ? (
                      <a
                        href={item?.cancel_file}
                        style={{ color: "red" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {steps.length - 1 === index1
                          ? item?.user_cancel_reason ?? item?.cancel_reason
                          : ""}
                      </a>
                    ) : null}
                  </td>
                  <td>{setLocalTime(item1.time)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Modal>
  );
};

export default ProcessModal;
